import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { SupplierDto } from '@api/models/suppliers/SupplierDto';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { EntityState } from '@api/models/enums/EntityState';
import { SupplierQueryParams } from '@api/params/SupplierQueryParams';
import { supplierService } from '@api/services/services';
import { selectIdentity } from './identity';
import { isExternal } from '../../utils/roles';

type State = BaseType<SupplierDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsSupplierSlice = baseSlice({
  name: 'optionsSupplier',
  initialState,
});

export const selectOptionsSupplierState = (state: RootState) => state.optionsSupplier.state;
export const selectOptionsSupplier = (state: RootState) => state.optionsSupplier.data.map((x) => ({ id: x.id, name: x.name }) as ReferenceDto);
export const optionsSupplierActions = optionsSupplierSlice.actions;

export const getOptionsSupplier =
  (search: string | undefined, cancelToken: CancelToken, canLendEmployees?: boolean) => (dispatch: AppDispatch, getState: () => RootState) => {
    const external = isExternal(selectIdentity(getState()));

    const handleGetData = async () => {
      const params: SupplierQueryParams = { q: search, state: EntityState.Active, page: 0, size: AUTOCOMPLETE_MAX_ITEMS, sort: ['name', 'asc'] };
      const options = { cancelToken: cancelToken as any };

      // External users can only borrow employees from suppliers explicitly allowed to lend to them,
      // which the backend serves via the dedicated lendable endpoint.
      const response =
        canLendEmployees && external
          ? await supplierService.queryLendableSuppliers(params, options)
          : await supplierService.query({ ...params, canLendEmployees }, options);

      return { data: response.data.content ?? [] };
    };

    getItem({
      dispatch,
      actions: optionsSupplierActions,
      getData: handleGetData,
    });
  };
